import curry from 'lodash/fp/curry';

export function isString(data: any): data is string {
  return typeof (data) === 'string';
}

export function isObject(data: unknown): data is object {
  return typeof (data) === 'object' && data !== null;
}

export function isFormData(data: unknown): data is FormData {
  return data instanceof FormData;
}

export function not(prevResult: boolean) {
  return !prevResult;
}

export function parseJson<T extends any>(data: string): T | null {
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
}

export function stringifyJson<T extends any>(data: T): string {
  try {
    return JSON.stringify(data);
  } catch {
    return '';
  }
}

export function normalizePhoneNumber(phone: string, noPlus = false) {
  const regexp = /[^\d]/ig;
  let result = phone.replace(regexp, '');

  if (result[0] === '8' && result.length === 11) {
    result = '7' + result.substring(1);
  }

  if (!noPlus && result[0] !== '+') {
    result = '+' + result;
  }

  return result;
}

export const property = (key: string, defValue: any, value: any) => {
  return value[key] ?? defValue;
};
export const prop = partialApply(property, 2);

export function partialApply(fn: Function, length: number) {
  return (...args: any[]) => {
    return fn.bind(null, ...args.slice(0, length));
  };
}

function _and(a: Function, b: Function, value: any) {
  return a(value) && b(value);
}

export const and = curry(_and);

export function activeWaitFor(predicate: Function, updateDelay: number, waitLimit = 1000) {
  return new Promise((resolve, reject) => {
    const resolver = (commulativeWait: number) => {
      if (predicate()) {
        resolve(true);
      } else if (commulativeWait >= waitLimit) {
        reject(new Error('Wait target is not happened'));
      } else {
        innerWait(commulativeWait + updateDelay);
      }
    };
    const innerWait = (commulativeWait: number, immediate = false) => {
      if (immediate) {
        resolver(0);
        return;
      }
      setTimeout(() => {
        resolver(commulativeWait);
      }, updateDelay);
    };
    innerWait(0, true);
  });
}

function _dataFilter(additional: any, predicate: Function, items: any[]) {
  return items.filter((item, index) => predicate(item, additional || index, index));
}
export const dataFilter = curry(_dataFilter);
